// src/utils/phoneValidation.js

// Bütün simvollardan yalnız rəqəmləri saxlayır
export const normalizePhone = (value = "") => value.replace(/\D/g, "");

// Burada öz formatını istənilən kimi sərtləşdirə bilərsən
// Məs: +994XXXXXXXXX və ya 0XXXXXXXXX
export const isValidPhone = (value = "") => {
  const digits = normalizePhone(value);

  // +994XXXXXXXXX → 12 rəqəm (994 + 9 rəqəm)
  if (/^994\d{9}$/.test(digits)) return true;

  // 0XXXXXXXXX → 10 rəqəm (0 + 9 rəqəm)
  if (/^0\d{9}$/.test(digits)) return true;

  return false;
};

/**
 * Xəta MƏTNİ deyil, tərcümə AÇARI qaytarır — mətn komponentdə
 * seçilmiş dilə uyğun t() ilə formalaşdırılır. Xəta yoxdursa "".
 */
export const getPhoneErrorKey = (value = "") => {
  if (!value.trim()) return "validation.phone_required";
  if (!isValidPhone(value)) return "validation.phone_invalid";
  return "";
};
